import RasterDatasetStore from '@/stores/dataset/raster-dataset-module';

interface IBbox {
  south: string | null;
  west: string | null;
  north: string | null;
  east: string | null;
}

export function isValidBbox<T extends IBbox>(bbox: T): boolean {
  return (
    bbox.south !== null &&
    bbox.north !== null &&
    bbox.west !== null &&
    bbox.east !== null &&
    RasterDatasetStore.isLonInsideBounds(parseFloat(bbox.east)) &&
    RasterDatasetStore.isLonInsideBounds(parseFloat(bbox.west)) &&
    RasterDatasetStore.isLatInsideBounds(parseFloat(bbox.north)) &&
    RasterDatasetStore.isLatInsideBounds(parseFloat(bbox.south))
  );
}
